export default "__VITE_ASSET__b3c7e0e9__"